import _ from 'lodash';

/**
 * @param {Array} groups
 * @param {Number} parentId
 * @return {Array}
 */
export const getSubGroupIdsByParentId = (groups, parentId) =>
  _.map(_.filter(groups, group => _.get(group, 'parent_group_id') === parentId), 'id');

/**
 * @param {Array} companyGroups
 * @param {Array} filterGroups
 * @return {Array}
 */
export const getGroupsWithSubGroups = (companyGroups, filterGroups) => {
  const subGroups = _.flatten(
    _.map(filterGroups, groupId => getSubGroupIdsByParentId(companyGroups, groupId)),
  );
  return _.uniq(_.concat(filterGroups, subGroups));
};

/**
 * @param {Array} companyGroups
 * @param {Number} groupId
 * @return {Object}
 */
export const getParentGroup = (companyGroups, groupId) => {
  const groupObject = _.get(companyGroups, groupId);
  return _.find(
    companyGroups,
    companyGroup => _.get(companyGroup, 'id') === _.get(groupObject, 'parent_group_id'),
  );
};
